import { yandexSplitContainer } from 'features/yandex-split-banner/styles';
import { css } from 'linaria';

export const hintStyles = css`
  position: relative;
  width: 100%;
  background: var(--accent-light);
  border-radius: var(--rounding-m);
  margin-bottom: var(--space-200);
  &:empty {
    display: none;
  }
`;

export const measurementHintMarginTop = css`
  .${yandexSplitContainer} + & {
    margin-top: var(--space-200);
  }
`;
